export const enumFromValue = <T extends Record<string, any>>(_enum: T, value: string | undefined): any | undefined => {
  if (value === undefined || value === "") return undefined;

  const lower = value.toLowerCase();

  const keys = Object.keys(_enum) as Array<keyof T>;

  const enumName = keys.find((k) => _enum[k].toLowerCase() === lower);
  if (enumName === undefined) throw new Error(`Unable to convert ${value} to enum ${_enum.name}`);
  if (typeof enumName === "string") {
    const num = Number(enumName); //_enum[enumName]
    if (!Number.isNaN(num)) return num as unknown as T;
  }

  return _enum[enumName];
};

export const enumToString = <T extends Record<string, any>>(_enum: T, value: number): string | undefined => {
  for (const k in _enum) if (_enum[k] === value) return k;
  return undefined;
};
